import ZignSec from './ZignSec';

export default ZignSec;
